/* eslint-disable radix */
import { mapGetters, mapMutations } from 'vuex';
import orderProductService from './../../services/orderProduct';
import batchService from './../../services/batch';
import { sortBatchOptions } from './../../utils/batchOptions';

export default {
  props: {
    order: {
      type: Object,
      required: true,
    },
    orderProduct: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      products: [],
      loading: true,
    };
  },
  computed: {
    ...mapGetters({
      batches: 'allBatches',
    }),
    list() {
      return this.products.map(((item) => {
        const batches = this.getProductBatches(item);
        return ({ id: item.id, name: item.name, batches, batchId: item.batchId.toString() });
      }));
    },
  },
  mounted() {
    this.getResources();
  },
  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),
    updateBatch(orderProductId, value) {
      orderProductService.batchUpdate(this.order.id, { batchId: value }, orderProductId);
    },
    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
    proceedToCreateBill() {
      this.$router.push({
        name: 'bills.create',
        query: {
          order: this.order.id,
        },
      });
      this.closeModal();
    },
    getProductBatches(item) {
      let productWarehouses = item.warehouses;
      if (this.order.warehouse.id && productWarehouses) {
        productWarehouses = productWarehouses.filter(p => parseInt(p.warehouseId) === parseInt(this.order.warehouse.id));
      }

      const batchIds = productWarehouses.map(p => +p.batchId);
      const batches = this.batches.filter(b => batchIds.includes(+b.id)).map((batch) => {
        const batchProduct = productWarehouses.find(p => +p.batchId === +batch.id);
        return Object.assign({}, {
          id: batch.id,
          name: this.order.warehouse.id ? `${batch.code} | ${this.$t('static.orders.edit.availableQty')}: ${batchProduct.qty}` : batch.code,
          qtyNumber: batchProduct.qtyNumber,
          available: batchProduct.qtyNumber,
        });
      });
      const nonBatchProduct = productWarehouses.find(p => p.batchId === 0);
      if (nonBatchProduct) {
        batches.unshift({
          id: '0',
          name: `${this.$t('static.orders.edit.nonBatch')} | ${this.$t('static.orders.edit.availableQty')}: ${nonBatchProduct.qty}`,
          qtyNumber: nonBatchProduct.qtyNumber,
          available: nonBatchProduct.qtyNumber,
        });
      }
      // Sort only: checkIfBatchIsPresent() decides from this list whether to show the popup.
      return this.order.warehouse.id ? sortBatchOptions(batches) : batches;
    },
    getResources() {
      this.loading = true;
      Promise.all([
        batchService.all({ warehouse_id: this.order.warehouseId, for_select: 1 }),
        orderProductService.all(this.order.id),
      ]).then((res) => {
        this.products = res[1];
        this.checkIfBatchIsPresent();
        this.loading = false;
      });
    },
    checkIfBatchIsPresent() {
      let hasBatch = false;
      this.list.forEach((item) => {
        if (item.batches.filter(b => +b.id !== 0).length > 0) {
          hasBatch = true;
        }
      });
      if (!hasBatch) {
        this.proceedToCreateBill();
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/components/batchAssignPopup/batchAssignPopup.js